import styled from "styled-components";

export const LoginStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
`;
